import "./footer.scss";

import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import Newsletter from "components/Newsletter/Newsletter";

const Footer = ({ data }) => {
	return (
		<>
			<Newsletter />
			<div className="footer">
				<div className="container">
					<div className="row">
						<div className="col-lg-3 col-12 footer__logo-col">
							<img
								src={
									require("assets/images/elcamp-logo.svg")
										.default
								}
								alt="Grupa Elcamp"
								className="footer__logo"
							/>
							<address className="footer__text-with-icon footer__text-with-icon--location">
								ul. Tyniecka 118 e, 30-376 Kraków
							</address>
							<a
								href="tel:+48122769006"
								className="footer__text-with-icon footer__text-with-icon--phone"
							>
								(+48) 12 276 90 06
							</a>
						</div>
						<div className="col-xl-2 col-sm-3 col-6">
							<div className="footer__list-title">
								Pojazdy kempingowe
							</div>
							<ul className="footer__menu">
								<li className="footer__menu-item">
									<Link
										to="/pojazdy-dostepne-od-reki"
										className="footer__menu-link"
									>
										Pojazdy dostępne od reki
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/nowe-kampery-i-nowe-przyczepy-campingowe/"
										className="footer__menu-link"
									>
										Pojazdy nowe
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/pojazdy-dostepne-od-reki/?used=true"
										className="footer__menu-link"
									>
										Pojazdy używane
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/odkup-pojazdow"
										className="footer__menu-link"
									>
										Odkup pojazdów
									</Link>
								</li>
							</ul>
						</div>
						<div className="col-xl-2 col-sm-3 col-6">
							<div className="footer__list-title">
								Serwis, części i akcesoria
							</div>
							<ul className="footer__menu">
								<li className="footer__menu-item">
									<Link
										to="/serwis"
										className="footer__menu-link"
									>
										Serwis
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/zawieszenia"
										className="footer__menu-link"
									>
										Zawieszenia
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/termika-i-oswietlenie"
										className="footer__menu-link"
									>
										Termika i oświetlenie
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/sklep-i-akcesoria"
										className="footer__menu-link"
									>
										Sklep i akcesoria
									</Link>
								</li>
							</ul>
						</div>
						<div className="col-sm-3 col-6">
							<div className="footer__list-title">Elcamp RV</div>
							<ul className="footer__menu">
								<li className="footer__menu-item">
									<Link
										to="/wynajem"
										className="footer__menu-link"
									>
										Wynajem
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/aktualnosci"
										className="footer__menu-link"
									>
										Aktualności
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/aktualnosci"
										className="footer__menu-link"
									>
										Targi i imprezy
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/aktualnosci"
										className="footer__menu-link"
									>
										Zloty
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/aktualnosci"
										className="footer__menu-link"
									>
										#Elcamperos
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/kariera"
										className="footer__menu-link footer__menu-link--career"
									>
										Kariera
										{data.edges.length > 0 && (
											<div className="footer__career-label">
												Zatrudniamy! (
												{data.edges.length})
											</div>
										)}
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/kontakt#o-nas"
										className="footer__menu-link"
									>
										O nas
									</Link>
								</li>
								<li className="footer__menu-item">
									<Link
										to="/kontakt"
										className="footer__menu-link"
									>
										Kontakt
									</Link>
								</li>
							</ul>
						</div>
					</div>
					<div className="footer__bottom-row">
						<div className="footer__bottom-menu">
							<Link
								to="/ogolne-warunki-sprzedazy-i-gwarancji"
								className="footer__bottom-menu-link"
							>
								Polityka prywatności
							</Link>
							<span className="footer__bottom-menu-divider">
								/
							</span>
							<Link
								to="/ogolne-warunki-sprzedazy-i-gwarancji"
								className="footer__bottom-menu-link"
							>
								Ogólne warunki sprzedaży i gwarancji
							</Link>
							<span className="footer__bottom-menu-divider">
								/
							</span>
							<Link
								to="/ogolne-warunki-sprzedazy-i-gwarancji"
								className="footer__bottom-menu-link"
							>
								Reklamacje
							</Link>
						</div>
						<div className="footer__socials-container">
							<a
								href="https://www.facebook.com/GrupaElcamp/"
								target="_blank"
								rel="noreferrer"
								className="footer__bottom-menu-social"
							>
								<img
									src={
										require("assets/icons/facebook.svg")
											.default
									}
									alt="Elcamp na Facebooku"
								/>
							</a>
							<a
								href="https://www.instagram.com/grupa_elcamp/"
								target="_blank"
								rel="noreferrer"
								className="footer__bottom-menu-social"
							>
								<img
									src={
										require("assets/icons/instagram.svg")
											.default
									}
									alt="Elcamp na Instagramie"
								/>
							</a>
							<a
								href="https://www.youtube.com/channel/UC5xNMylmVKGlcotQYHxAmfw"
								target="_blank"
								rel="noreferrer"
								className="footer__bottom-menu-social"
							>
								<img
									src={
										require("assets/icons/youtube.svg")
											.default
									}
									alt="Elcamp na Youtubie"
								/>
							</a>
						</div>
					</div>
					<div className="footer__copyright-text">
						© 2021 Elcamp RV sp. z o.o. ul. Tyniecka 118e, 30-376
						Kraków REGON: 120939158 KRS: 0000965816 NIP:
						679-301-03-95
						<br />
						<br />
						Gdy użytkownik odwiedza lub wchodzi w interakcję z
						naszymi witrynami, usługami lub narzędziami, my lub nasi
						autoryzowani dostawcy usług mogą używać plików cookie do
						przechowywania informacji w celu zapewnienia lepszego,
						szybszego i bezpieczniejszego korzystania z nich oraz w
						celach marketingowych.
					</div>
					<div className="footer__developed">
						<p>
							Realizacja:{" "}
							<a href="https://adream.pl/" target="_blank">
								<img
									src={
										require("../../assets/images/logo-adream.svg")
											.default
									}
									alt=""
								/>
							</a>
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default () => (
	<StaticQuery
		query={graphql`
			{
				data: allWpCareer {
					edges {
						node {
							id
						}
					}
				}
			}
		`}
		render={(data) => <Footer {...data} />}
	/>
);
